
  
const initState = {
    trainingCategory: []
  };
  
  const TrainingCategoryReducer = (state = initState, action) => {
    switch (action.type) {
      case 'SET_TRAINING_CATEGORY':
        return {
          ...state,
          trainingCategory: action.payload.data
        };
      case 'RESET_TRAINING_CATEGORY_STATE':
        return {
          ...state,
          ...initState
        };
      default:
        return { ...state };
    }
  };
  
  export default TrainingCategoryReducer;
  